import { money } from "@/lib/api";

export const PriceBreakdown = ({ quote, testid = "price-breakdown" }) => {
  if (!quote) return null;
  return (
    <div data-testid={testid} className="rounded-xl border border-slate-200 bg-[#FAF8F1] p-5">
      <p className="font-mono-x text-[10px] uppercase tracking-widest text-gold">Itemized estimate</p>
      <ul className="mt-3 space-y-2">
        {quote.items.map((it) => (
          <li key={it.label} className="flex justify-between gap-4 text-sm text-slate-600">
            <span>{it.label}</span>
            <span className="font-medium text-[#0B132B]">{money(it.amount)}</span>
          </li>
        ))}
      </ul>
      <div className="mt-4 flex items-end justify-between border-t border-slate-300 pt-4">
        <span className="text-sm font-semibold text-[#0B132B]">Estimated total</span>
        <span data-testid={`${testid}-total`} className="font-display text-2xl font-bold text-[#0B132B]">
          {money(quote.total)}
        </span>
      </div>
      {quote.custom_quote && (
        <p data-testid={`${testid}-custom`} className="mt-3 text-xs text-slate-500">
          Properties over this size receive a custom quote. You can still request a time and we will confirm pricing before the inspection.
        </p>
      )}
      {quote.in_service_area === false && (
        <p data-testid={`${testid}-outside-area`} className="mt-3 text-xs font-medium text-red-600">
          This ZIP code is outside our current service area. Please contact us to check availability.
        </p>
      )}
      <p className="mt-3 text-[11px] text-slate-400">Estimate only. Final price is confirmed after review of property details.</p>
    </div>
  );
};
